/**
 * @file Schools onboarding head metadata.
 */

import React from 'react';
import Helmet from 'react-helmet';

import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';

const OnboardingLandingSchoolsHeadMeta = () => {
  const {
    app: { pageUrl },
  } = getConfig();

  return (
    <Helmet>
      <title>Get pics of your student texted to your phone!</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Get pics of your student texted to your phone!"
      />
      <meta
        property="og:description"
        content="Hi! I’m Waldo, your photo-finding phenom at school. I’m here to help you get all the photos your school takes of your student – all year long - and deliver them right to your phone!"
      />
      <meta
        property="og:image"
        content={getAsset('/school-landing-hero-1.jpg')}
      />
    </Helmet>
  );
};

export default OnboardingLandingSchoolsHeadMeta;
